import React from 'react';

interface InfoItemProps {
  icon: React.ReactNode;
  text: string | null | undefined;
}

const InfoItem: React.FC<InfoItemProps> = ({ icon, text }) => {
  if (!text) return null;
  return (
    <div className="flex items-center space-x-2 text-gray-600">
      {icon}
      <span className="text-sm">{text}</span>
    </div>
  );
};

export default InfoItem;
